import React from 'react';
import { connect } from 'react-redux';
import {Button, Card, Checkbox, Col, Form, Input, message, Row, Select, Tooltip} from "antd";
import {Link} from "react-router-dom";
import {EyeInvisibleOutlined, EyeOutlined} from "@ant-design/icons";
import countryList from 'react-select-country-list'
import {registerAccount, validateEmailAddress, validateVAT} from "../../actions/auth";
import {displayErrors, getCookieValue} from "../../libs/utils";
import {updatePage} from "../../actions/page";
import getBrowserFingerprint from 'get-browser-fingerprint';
import {loadPrivacyPolicy, loadTermsOfService} from "../../actions/account";

class Register extends React.Component  {
    state = {
        step: 1,

        email: '',
        password: '',
        first_name: '',
        last_name: '',
        company_name: '',
        address1: '',
        address2: '',
        city: '',
        region: '',
        postal_code: '',
        country: '',
        currency: 'USD',
        found_us: '',
        found_us_selection: '',
        vat_id: '',

        invalid_company: false,
        vat_is_valid: true,

        agreeTerms: false,

        validatingInitialData: false,

        passwordInputType: 'password',

        fingerprint: null,

        termsOfServiceText: '',
        privacyPolicyText: '',
        tosDisabled: true,
        privacyDisabled: true,
        registering: false,
    };

    countries = countryList().getData();

    componentDidMount() {
        this.props.updatePage('Register');
        getBrowserFingerprint({hardwareOnly: false}).then(result => this.setState({ fingerprint: result }));

        this.props.loadTermsOfService((res) => {
            this.setState({ termsOfServiceText: res.data.terms_of_service });
        });

        this.props.loadPrivacyPolicy((res) => {
            this.setState({ privacyPolicyText: res.data.privacy_policy });
        });
    }

    nextStep() {
        if(this.state.step === 1) {
            if(this.state.email.trim().length === 0) {
                return message.error('Please enter your email address!');
            }

            if(this.state.password.trim().length === 0) {
                return message.error('Please enter your password!');
            }

            if(this.state.vat_id.trim().length !== 0) {
                this.setState({ validatingInitialData: true });

                let data = {
                    'vat_id': this.state.vat_id,
                    'company_name': this.state.company_name
                };

                this.props.validateVAT(data, (res) => {
                    if(res.data.is_valid) {
                        this.setState({ step: 2, invalid_company: false, vat_is_valid: true, validatingInitialData: false });
                    } else {
                        if(res.data.invalid_company) {
                            this.setState({ invalid_company: true, vat_is_valid: true, validatingInitialData: false });
                        } else if(!res.data.is_valid) {
                            this.setState({ invalid_company: false, vat_is_valid: false, validatingInitialData: false });
                        }
                    }
                }, (err) => {
                    if(typeof err.response !== 'undefined') {
                        displayErrors(err.response.data);
                        this.setState({ loading: false, validatingInitialData: false });
                    }
                });
            } else {
                this.setState({ step: 2 });
            }
        } else if(this.state.step === 2) {
            this.setState({ step: 3 });
        } else if(this.state.step === 3) {
            this.setState({ step: 4 });
        } else if(this.state.step === 4) {
            this.setState({ step: 5 });
        }
    }

    previousStep() {
        if(this.state.step === 2) {
            this.setState({ step: 1 });
        } else if(this.state.step === 3) {
            this.setState({ step: 2 });
        } else if(this.state.step === 4) {
            this.setState({ step: 3 });
        } else if(this.state.step === 5) {
            this.setState({ step: 4 });
        }
    }

    createAccount() {
        let email = this.state.email.trim();
        let password = this.state.password.trim();
        let first_name = this.state.first_name.trim();
        let last_name = this.state.last_name.trim();
        let company_name = this.state.company_name.trim();
        let address1 = this.state.address1.trim();
        let address2 = this.state.address2.trim();
        let city = this.state.city.trim();
        let region = this.state.region.trim();
        let postal_code = this.state.postal_code.trim();
        let country = this.state.country.trim();
        let currency = this.state.currency.trim();
        let agree_terms = this.state.agreeTerms;
        let found_us = this.state.found_us;
        let vat_id = this.state.vat_id;

        if(email.length === 0) {
            return message.error('Please enter your email address!');
        }

        if(password.length === 0) {
            return message.error('Please enter your password!');
        }

        if(first_name.length === 0) {
            return message.error('Please enter your first name!');
        }

        if(last_name.length === 0) {
            return message.error('Please enter your last name!');
        }

        if(company_name.length === 0) {
            return message.error('Please enter your company name!');
        }

        if(address1.length === 0) {
            return message.error('Please enter your address!');
        }

        if(city.length === 0) {
            return message.error('Please enter your city!');
        }

        if(region.length === 0) {
            return message.error('Please enter your region!');
        }

        if(postal_code.length === 0) {
            return message.error('Please enter your postal code!');
        }

        if(country.length === 0) {
            return message.error('Please enter your country!');
        }

        if(currency.length === 0) {
            return message.error('Please enter your currency!');
        }

        if(found_us.length === 0) {
            return message.error('Please describe how did you find us!');
        }

        const fingerprint = this.state.fingerprint;

        let data = {
            email, password, first_name, last_name, company_name, address1, address2,
            city, region, postal_code, country, agree_terms, currency, found_us,
            vat_id, fingerprint
        };

        window.location.search.substring(1).split('&').forEach(value => {
            let pieces = value.split('=');
            data[pieces[0]] = pieces[1];
        });

        if(window.location.search === '') {
            ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term', 'aff_click_id'].forEach(value => {
                if(getCookieValue(value) !== '') {
                    data[value] = getCookieValue(value);
                }
            })
        }

        this.setState({ loading: true, registering: true });

        this.props.registerAccount(data, () => {
            this.props.history.push('/auth/login?registration=successful');
            this.setState({ loading: false, registering: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false, registering: false });
            }
        });
    }

    updateFoundUs(value) {
        let data = {
            found_us_selection: value
        };

        if(value !== 'OTHER') {
            data['found_us'] = value;
        } else {
            data['found_us'] = '';
        }

        this.setState(data);
    }

    validateProfileInfo() {
        if(this.state.email.trim().length === 0) {
            return message.error('Please enter your email address!');
        }

        if(!this.state.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            return message.error('Please enter a valid email address!');
        }

        if(this.state.password.trim().length === 0) {
            return message.error('Please enter your password!');
        }

        if(this.state.first_name.trim().length === 0) {
            return message.error('Please enter your first name!');
        }

        if(this.state.last_name.trim().length === 0) {
            return message.error('Please enter your last name!');
        }

        if(this.state.company_name.trim().length < 5) {
            return message.error('Please enter a correct company name or enter your full name!');
        }

        if(this.state.vat_id.length > 0) {
            if(this.state.vat_id.length > 15) {
                return message.error('Please enter a valid VAT ID!');
            }
        }

        let bad_company_names = ['no company', 'none', 'own', 'not available', 'notavailable', 'nil', 'na',
            'n/a', 'work', 'info', 'personal', 'test', 'unknown', 'sample', 'other', 'company'];

        if(bad_company_names.indexOf(this.state.company_name.trim().toLowerCase()) !== -1) {
            return message.error('If you don\'t have a company name, please enter your full name!');
        }

        this.setState({ validatingInitialData: true });

        this.props.validateEmailAddress({'email': this.state.email}, () => {
            this.nextStep();
            this.setState({ validatingInitialData: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ validatingInitialData: false });
            }
        });
    }

    validateCompanyInfo() {

        if(this.state.address1.trim().length === 0) {
            return message.error('Please enter your address!');
        }

        if(this.state.city.trim().length === 0) {
            return message.error('Please enter your city!');
        }

        if(this.state.region.trim().length === 0) {
            return message.error('Please enter your region!');
        }

        if(this.state.postal_code.trim().length === 0) {
            return message.error('Please enter your postal code!');
        }

        if(this.state.country.trim().length === 0) {
            return message.error('Please enter your country!');
        }

        if(this.state.found_us.length === 0) {
            return message.error('Please describe how did you find us!');
        }

        if(this.state.found_us_selection === 'OTHER' || this.state.found_us_selection === 'CONFERENCE' ) {
            if(this.state.found_us.trim().length === 0) {
                return message.error('Please be specific about where you found us!');
            }
        }

        this.nextStep();
    }

    handleTosScroll = e => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        const reachedBottom = scrollTop + clientHeight >= scrollHeight - 5;

        if (reachedBottom && this.state.tosDisabled) {
            this.setState({ tosDisabled: false });
        }
    };

    handlePrivacyScroll = e => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        const reachedBottom = scrollTop + clientHeight >= scrollHeight - 5;

        if (reachedBottom && this.state.privacyDisabled) {
            this.setState({ privacyDisabled: false });
        }
    };

    updateCompanyName() {
        const fullName = this.state.first_name + ' ' + this.state.last_name;
        this.setState({ company_name: fullName });
    }

    render() {
        let content = '';
        const { Option } = Select;

        if(this.state.step === 1) {
            content = <Form layout='vertical' key='user-info-page'>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label='First name'>
                            <Input value={this.state.first_name} onChange={(e) => this.setState({ first_name: e.target.value }, () => this.updateCompanyName())} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label='Last name'>
                            <Input value={this.state.last_name} onChange={(e) => this.setState({ last_name: e.target.value }, () => this.updateCompanyName())} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item label='Email address'>
                    <Input value={this.state.email} type='email'
                           onChange={(e) => this.setState({ email: e.target.value })} />
                </Form.Item>
                <Form.Item label='Password' help={<small>Click on the eye icon on the right to view your password.</small>}>
                    <Input value={this.state.password} type={this.state.passwordInputType}
                           onChange={(e) => this.setState({ password: e.target.value })}
                           suffix={this.state.passwordInputType === 'text' ? <Tooltip title='Hide password'><EyeInvisibleOutlined onClick={() => this.setState({ passwordInputType: 'password' })} /></Tooltip> : <Tooltip title='Show password'><EyeOutlined onClick={() => this.setState({ passwordInputType: 'text' })} /></Tooltip> }/>
                </Form.Item>
                <Form.Item style={{marginBottom: '5px'}} label='Company name' extra={this.state.invalid_company ? <small style={{color: 'red'}}>Company name does not match the company name used for VAT registration. Please ensure that your company name <b><u>exactly</u></b> matches the company name in your country's registry. <a target='_blank' rel='noopener noreferrer' href='https://ec.europa.eu/taxation_customs/vies/#/vat-validation'>Click here</a> to verify the company name.</small> : <small>If you don't have a company, enter your full name.</small>}>
                    <Input status={this.state.invalid_company ? 'error': ''} value={this.state.company_name} onChange={(e) => this.setState({ company_name: e.target.value })} />
                </Form.Item>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item label='VAT ID' extra={<small>Optional. Valid format: EE123456789. {!this.state.vat_is_valid ? <span style={{color: 'red'}}>Invalid VAT ID! </span> : ''}</small>}>
                            <Input status={!this.state.vat_is_valid ? 'error': ''} value={this.state.vat_id} onChange={(e) => this.setState({ vat_id: e.target.value })} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label='Currency' extra={<small>Currency cannot be changed later!</small>}>
                            <Select value={this.state.currency} onChange={(value) => this.setState({ currency: value })}>
                                <Option value='USD'>USD</Option>
                                <Option value='EUR'>EUR</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Button block loading={this.state.validatingInitialData} disabled={this.state.validatingInitialData}
                        type='primary' onClick={() => this.validateProfileInfo()}>Continue</Button>
                <div className='auth-mobile-button'>
                    <Link to={'/auth/login' + window.location.search}>
                        <Button style={{ width: '100%', marginTop: '15px'}}>Login</Button>
                    </Link>
                </div>
            </Form>;
        } else if(this.state.step === 2) {
            const { Option } = Select;
            const { TextArea } = Input;

            content = <Form layout='vertical' key='billing-info-page'>
                <Form.Item label='Address'>
                    <Input value={this.state.address1} onChange={(e) => this.setState({ address1: e.target.value })} />
                </Form.Item>
                <Form.Item label='Address 2' help={<small>Optional</small>}>
                    <Input value={this.state.address2} onChange={(e) => this.setState({ address2: e.target.value })} />
                </Form.Item>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label='City'>
                            <Input value={this.state.city} onChange={(e) => this.setState({ city: e.target.value })} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label='Region'>
                            <Input value={this.state.region} onChange={(e) => this.setState({ region: e.target.value })} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label='Country'>
                            <Select
                                placeholder='Select country'
                                showSearch
                                filterOption={(input, option) => {
                                    if(typeof option !== 'undefined') {
                                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                    }
                                    return false;
                                }}
                                value={this.state.country}
                                onChange={(value) => this.setState({ country: value })}>
                                {this.countries.map((key) => {
                                    return <Option key={key.value} value={key.value}>{key.label}</Option>;
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label='Postal code'>
                            <Input value={this.state.postal_code} onChange={(e) => this.setState({ postal_code: e.target.value })} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item label='How did you hear about us?'>
                    <Select value={this.state.found_us_selection} onChange={(value) => this.updateFoundUs(value)}>
                        <Option value='LINKED_IN'>LinkedIn</Option>
                        <Option value='CONFERENCE'>Conference</Option>
                        <Option value='GOOGLE'>Google</Option>
                        <Option value='CHATGPT'>ChatGPT</Option>
                        <Option value='GEMINI'>Google Gemini</Option>
                        <Option value='CLAUDE'>Claude</Option>
                        <Option value='DEEPSEEK'>DeepSeek</Option>
                        <Option value='GROK'>Grok</Option>
                        <Option value='PERPLEXITY'>Perplexity</Option>
                        <Option value='REDDIT'>Reddit</Option>
                        <Option value='FACEBOOK'>Facebook</Option>
                        <Option value='INSTAGRAM'>Instagram</Option>
                        <Option value='OTHER'>Other</Option>
                    </Select>
                </Form.Item>
                {this.state.found_us_selection === 'OTHER' || this.state.found_us_selection === 'CONFERENCE' ? <Form.Item label='Please be more specific:'>
                    <TextArea value={this.state.found_us} onChange={(e) => this.setState({ found_us: e.target.value })} />
                </Form.Item> : ''}
                <Button block type='primary' onClick={() => this.validateCompanyInfo()}>Continue</Button>
                <Button block type='default' style={{ width: '100%', marginTop: '15px'}} onClick={() => this.previousStep()}>Back</Button>

            </Form>;
        } else if(this.state.step === 3) {

            content = <div id='tos-content' key='terms-of-service-page'>
                <h1 className='text-center'>Terms Of Service</h1>
                <div id='tos-container' key='terms-of-service' className='tos-container terms-container' onScroll={this.handleTosScroll} dangerouslySetInnerHTML={{__html: this.state.termsOfServiceText}} />
                <Button block type='primary' disabled={this.state.tosDisabled} onClick={() => this.nextStep()}>I agree with Priority Prospect's Terms of Service</Button>
                <Button block type='default' style={{ width: '100%', marginTop: '15px'}} onClick={() => this.previousStep()}>Back</Button>
            </div>
        } else if(this.state.step === 4) {
            content = <div id='privacy-policy-content' key='privacy-policy-page'>
                <h1 className='text-center'>Privacy Policy</h1>
                <div id='privacy-policy' key='privacy-policy' className='privacy-policy terms-container' onScroll={this.handlePrivacyScroll} dangerouslySetInnerHTML={{__html: this.state.privacyPolicyText}} />
                <Button block type='primary' disabled={this.state.privacyDisabled} onClick={() => this.nextStep()}>I agree with Priority Prospect's Privacy Policy</Button>
                <Button block type='default' style={{ width: '100%', marginTop: '15px'}} onClick={() => this.previousStep()}>Back</Button>
            </div>
        } else if(this.state.step === 5) {
            content = <Form layout='vertical' key='confirmation-page'>
                <Form.Item>
                    <Checkbox onChange={(e) => this.setState({ agreeTerms: e.target.checked }) }>
                        <p>I confirm that I am at least 18 years old and that I have read, understand, and agree to be legally bound by Priority Prospect OÜ's <a href='https://priorityprospect.com/legal/terms-of-service/' rel="noopener noreferrer"  target='_blank'><b>terms of service</b></a> and <a href='https://priorityprospect.com/legal/privacy-policy/' rel="noopener noreferrer"  target='_blank'><b>privacy policy</b></a>.</p>
                        <p>These services are intended for professional and business use. If you qualify as a consumer under applicable law, mandatory consumer protections apply.</p>
                    </Checkbox>
                </Form.Item>

                <Button block type='primary' loading={this.state.registering} disabled={!this.state.agreeTerms || this.state.registering} onClick={() => this.createAccount()}>Create Account</Button>
                <Button block type='default' style={{marginTop: '15px'}} onClick={() => {
                    this.setState({ agreeTerms: false });
                    this.previousStep();
                }}>Back</Button>
            </Form>;
        }

        return(
            <div className='auth-wrapper'>
                <Card className='form-container'>
                    <div className='logo-container'>
                        <img alt='Priority Prospect' src='/img/logo.svg' />
                    </div>
                    {content}
                </Card>
            </div>
        );
    }
}

export default connect(null, { updatePage, registerAccount, validateVAT,
    validateEmailAddress, loadTermsOfService, loadPrivacyPolicy })(Register);